import React from 'react';
import {EncForm, EncInputField, EncCheckboxField, EncSelectField, withEncFormHandler} from '../../../../../../../../../components/hocs/form-validation';
import {withTranslation} from 'react-i18next';
import forge from 'node-forge';

const IDENTITY_TYPE_OPTIONS = [
    {key: 'MTLS_CERTIFICATE', value: 'MTLS_CERTIFICATE', text: 'mTLS Certificate'}
];

const parsePemCertificate = (pem) => {
    try {
        const cert = forge.pki.certificateFromPem(pem);
        const derBytes = forge.asn1.toDer(forge.pki.certificateToAsn1(cert)).getBytes();
        const thumbprint = forge.md.sha256.create().update(derBytes).digest().toHex()
            .match(/.{2}/g).join(':').toUpperCase();
        const cnField = cert.subject.getField('CN');

        return {
            thumbprint,
            subjectCN: cnField ? cnField.value : '',
            notBefore: cert.validity.notBefore.toISOString().slice(0, 16),
            notAfter: cert.validity.notAfter.toISOString().slice(0, 16)
        };
    } catch (e) {
        return null;
    }
};

let AddIdentity = (props) => {
    const {formProperties, fieldProperties, t} = props;

    const processCertificate = (pem) => {
        if (!pem || !pem.includes('BEGIN CERTIFICATE')) {
            return;
        }

        const parsed = parsePemCertificate(pem);
        if (parsed) {
            if (parsed.thumbprint) {
                props.setFieldValue('value', parsed.thumbprint);
            }
            if (parsed.subjectCN) {
                props.setFieldValue('description', parsed.subjectCN);
            }
            if (parsed.notBefore) {
                props.setFieldValue('notBefore', parsed.notBefore);
            }
            if (parsed.notAfter) {
                props.setFieldValue('notAfter', parsed.notAfter);
            }
        }
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            processCertificate(event.target.result);
        };
        reader.readAsText(file);
    };

    return (
        <EncForm formProperties={formProperties} fieldProperties={fieldProperties}>
            <EncSelectField
                id="identityType"
                label="user:user.identity.type"
                options={IDENTITY_TYPE_OPTIONS}
                validator={{
                    type: 'string',
                    rules: ['required']
                }}
            />
            <div className="form-group" style={{padding: '0.5rem 0', marginTop: '1rem', marginBottom: '1rem'}}>
                <label>{t('user:user.identity.certificate')}</label>
                <input
                    type="file"
                    className="form-control"
                    accept=".pem,.crt,.cer,.cert"
                    onChange={handleFileUpload}
                />
            </div>
            <EncInputField
                id="value"
                label="user:user.identity.value"
                disabled={true}
                validator={{
                    type: 'string',
                    rules: ['required']
                }}
            />
            <EncInputField
                id="description"
                label="user:user.identity.description"
                disabled={true}
            />
            <EncInputField
                id="notBefore"
                type="datetime-local"
                label="user:user.identity.not.before"
                disabled={true}
            />
            <EncInputField
                id="notAfter"
                type="datetime-local"
                label="user:user.identity.not.after"
                disabled={true}
            />
            <EncCheckboxField
                id="active"
                label="user:user.identity.active"
            />
        </EncForm>
    );
};

const FORM_VALIDATION_OPTIONS = {
    header: 'user:user.add.identity',
    successMessage: 'user:user.identity.successfully.added',
    validateOnChange: false,
    validateOnBlur: true
};

AddIdentity = withTranslation()(AddIdentity);

export default withEncFormHandler(FORM_VALIDATION_OPTIONS)(AddIdentity);
